export function filterAndSearchConditions({
	conditions = [],
	searchQuery = '',
	selectedPatientTypes = [],
	selectedDiseaseCategories = []
}) {
	let filtered = conditions
	if (searchQuery) {
		const query = searchQuery.toLowerCase()
		filtered = filtered.filter(condition => {
			const titleMatch = condition.title && condition.title.toLowerCase().includes(query)
			const categoryMatch = condition.category && condition.category.toLowerCase().includes(query)
			const patientTypeMatch = (condition.patientTypes || []).some(pt =>
				pt.key && pt.key.toLowerCase().includes(query)
			)
			const categoryKeyMatch = condition.categoryKey && condition.categoryKey.toLowerCase().includes(query)
			return titleMatch || patientTypeMatch || categoryKeyMatch || categoryMatch
		})
	}
	if (selectedPatientTypes.length > 0) {
		filtered = filtered.filter(condition =>
			(condition.patientTypes || []).some(type =>
				selectedPatientTypes.includes(type.key)
			)
		)
	}
	if (selectedDiseaseCategories.length > 0) {
		filtered = filtered.filter(condition => selectedDiseaseCategories.includes(condition.categoryKey))
	}
	return filtered
}
